export default {
    populateNotifications (state, data) {
        state.notifications = data
    },

    addNotification (state, notification) {
        state.notifications.unshift(notification)
    },

    removeNotification (state, id) {
        state.notifications = state.notifications.filter(notification => notification.id !== id)
    },

    removeJobNotifications (state, jobId) {
        state.notifications = state.notifications.filter(notification => notification.job_id !== jobId)
    },

    clearNotifications (state) {
        state.notifications = []
    }
}
